import { Ban, CreditCard, Truck } from "lucide-react";
import { observer } from "mobx-react";
import React from "react";
import { Button } from "randmarcomps";
import Return from "../../stores/return/Return";

interface IProps {
  returnDocument: Return;
}

const SingleReturnActions: React.FC<IProps> = ({ returnDocument }) => {
  //if (createLabel) return (<Navigate to={Path.category(applicationId, product?.category)} />);

  return (
    <div className="mx-1 my-2 flex w-[260px] flex-col gap-3">
      <div className="space-y-2">
        <p className="px-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Return {returnDocument.returnNumber || "—"}
        </p>
        <div className="flex flex-col gap-1">
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <Ban className="h-4 w-4" aria-hidden="true" />
            Decline
          </Button>
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <CreditCard className="h-4 w-4" aria-hidden="true" />
            Credit
          </Button>
        </div>
      </div>

      <hr className="border-slate-100" />

      <div className="space-y-2">
        <p className="px-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Utilities</p>
        <div className="flex flex-col gap-1">
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <Truck className="h-4 w-4" aria-hidden="true" />
            Create return label
          </Button>
        </div>
      </div>

      <div className="rounded-xl border border-slate-100 bg-slate-50 p-3">
        <p className="text-[13px] text-slate-600">Return actions are coming soon.</p>
      </div>
    </div>
  );
};

export default observer(SingleReturnActions);
